import { LogoImage } from "./Logo";

export const Footer = ({ onNav }) => {
  const go = (e, href) => {
    e.preventDefault();
    onNav(href);
  };

  return (
    <footer data-testid="site-footer" className="safe-b border-t-4 border-orange bg-navy py-14 text-white">
      <div className="safe-x mx-auto grid max-w-7xl gap-10 md:grid-cols-3">
        <div>
          <a href="#top" data-testid="footer-logo" className="flex items-center gap-3" onClick={(e) => go(e, "#top")}>
            <LogoImage className="h-14 w-auto" />
          </a>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
            Glass repair, handyman work and garden maintenance for Southern Adelaide. Practical,
            straight-up, done properly.
          </p>
        </div>

        <div>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-orange">Contact</p>
          <ul className="mt-5 space-y-3 text-sm text-white/75">
            <li>
              <a
                href="tel:0424424600"
                data-testid="footer-phone-link"
                className="transition-colors duration-200 hover:text-orange"
              >
                0424 424 600
              </a>
            </li>
            <li>
              <a
                href="mailto:admin@panereliefglass.com"
                data-testid="footer-email-link"
                className="break-all transition-colors duration-200 hover:text-orange"
              >
                admin@panereliefglass.com
              </a>
            </li>
            <li className="text-white/50">Servicing Southern Adelaide, SA</li>
          </ul>
        </div>

        <div>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-orange">Quick links</p>
          <ul className="mt-5 space-y-3 text-sm text-white/75">
            {[
              { label: "Services", href: "#services", testid: "footer-link-services" },
              { label: "Areas", href: "#areas", testid: "footer-link-areas" },
              { label: "Contact", href: "#contact", testid: "footer-link-contact" },
            ].map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={link.testid}
                  className="transition-colors duration-200 hover:text-orange"
                  onClick={(e) => go(e, link.href)}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="safe-x mx-auto mt-12 max-w-7xl border-t border-white/10 pt-6">
        <p className="text-xs uppercase tracking-wider text-white/40">
          &copy; 2026 Pane Relief &mdash; Southern Adelaide. We fix it.
        </p>
      </div>
    </footer>
  );
};
